let apiUrl = process.env.VUE_APP_API_URL;
let wsUrl = process.env.VUE_APP_WS_URL;

if (!apiUrl) {
  apiUrl = window.location.origin + '/api';
}

if (!wsUrl) {
  wsUrl = window.location.origin + '/ws';
}

module.exports = {
    API_LOCATION: apiUrl,
    WS_LOCATION: wsUrl
}
